// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes in-btn-social-0a1896fa{0%{left:-110%;top:90%}50%{left:10%;top:-30%}100%{top:-10%;left:-10%}}@keyframes out-btn-social-0a1896fa{0%{top:-10%;left:-10%}50%{left:10%;top:-30%}100%{left:-110%;top:90%}}.content[data-v-0a1896fa]{position:relative}.simplified-layout-wrapper[data-v-0a1896fa]{display:flex;flex-direction:column;min-height:100vh}.simplified-layout-footer[data-v-0a1896fa]{margin-top:auto;padding:1.5rem 0}", ""]);
// Exports
module.exports = exports;
